var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 55,
    viewBox: "0 0 67 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.89235 7.78466C6.04203 7.78466 7.78466 6.04203 7.78466 3.89235C7.78466 1.74267 6.04203 0 3.89235 0C1.74267 0 0 1.74267 0 3.89235C0 6.04203 1.74267 7.78466 3.89235 7.78466Z",
    fill: "url(#paint0_linear_740_11517)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5251 7.78466C25.6748 7.78466 27.4175 6.04203 27.4175 3.89235C27.4175 1.74267 25.6748 0 23.5251 0C21.3754 0 19.6328 1.74267 19.6328 3.89235C19.6328 6.04203 21.3754 7.78466 23.5251 7.78466Z",
    fill: "url(#paint1_linear_740_11517)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.158 7.78466C45.3077 7.78466 47.0503 6.04203 47.0503 3.89235C47.0503 1.74267 45.3077 0 43.158 0C41.0083 0 39.2656 1.74267 39.2656 3.89235C39.2656 6.04203 41.0083 7.78466 43.158 7.78466Z",
    fill: "url(#paint2_linear_740_11517)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7829 7.78466C64.9326 7.78466 66.6753 6.04203 66.6753 3.89235C66.6753 1.74267 64.9326 0 62.7829 0C60.6333 0 58.8906 1.74267 58.8906 3.89235C58.8906 6.04203 60.6333 7.78466 62.7829 7.78466Z",
    fill: "url(#paint3_linear_740_11517)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89235 23.5229C6.04203 23.5229 7.78466 21.7803 7.78466 19.6306C7.78466 17.481 6.04203 15.7383 3.89235 15.7383C1.74267 15.7383 0 17.481 0 19.6306C0 21.7803 1.74267 23.5229 3.89235 23.5229Z",
    fill: "url(#paint4_linear_740_11517)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5251 23.5229C25.6748 23.5229 27.4175 21.7803 27.4175 19.6306C27.4175 17.481 25.6748 15.7383 23.5251 15.7383C21.3754 15.7383 19.6328 17.481 19.6328 19.6306C19.6328 21.7803 21.3754 23.5229 23.5251 23.5229Z",
    fill: "url(#paint5_linear_740_11517)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.158 23.5229C45.3077 23.5229 47.0503 21.7803 47.0503 19.6306C47.0503 17.481 45.3077 15.7383 43.158 15.7383C41.0083 15.7383 39.2656 17.481 39.2656 19.6306C39.2656 21.7803 41.0083 23.5229 43.158 23.5229Z",
    fill: "url(#paint6_linear_740_11517)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7829 23.5229C64.9326 23.5229 66.6753 21.7803 66.6753 19.6306C66.6753 17.481 64.9326 15.7383 62.7829 15.7383C60.6333 15.7383 58.8906 17.481 58.8906 19.6306C58.8906 21.7803 60.6333 23.5229 62.7829 23.5229Z",
    fill: "url(#paint7_linear_740_11517)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89235 39.2612C6.04203 39.2612 7.78466 37.5185 7.78466 35.3689C7.78466 33.2192 6.04203 31.4766 3.89235 31.4766C1.74267 31.4766 0 33.2192 0 35.3689C0 37.5185 1.74267 39.2612 3.89235 39.2612Z",
    fill: "url(#paint8_linear_740_11517)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5251 39.2612C25.6748 39.2612 27.4175 37.5185 27.4175 35.3689C27.4175 33.2192 25.6748 31.4766 23.5251 31.4766C21.3754 31.4766 19.6328 33.2192 19.6328 35.3689C19.6328 37.5185 21.3754 39.2612 23.5251 39.2612Z",
    fill: "url(#paint9_linear_740_11517)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.158 39.2612C45.3077 39.2612 47.0503 37.5185 47.0503 35.3689C47.0503 33.2192 45.3077 31.4766 43.158 31.4766C41.0083 31.4766 39.2656 33.2192 39.2656 35.3689C39.2656 37.5185 41.0083 39.2612 43.158 39.2612Z",
    fill: "url(#paint10_linear_740_11517)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7829 39.2612C64.9326 39.2612 66.6753 37.5185 66.6753 35.3689C66.6753 33.2192 64.9326 31.4766 62.7829 31.4766C60.6333 31.4766 58.8906 33.2192 58.8906 35.3689C58.8906 37.5185 60.6333 39.2612 62.7829 39.2612Z",
    fill: "url(#paint11_linear_740_11517)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89235 55.0005C6.04203 55.0005 7.78466 53.2578 7.78466 51.1081C7.78466 48.9584 6.04203 47.2158 3.89235 47.2158C1.74267 47.2158 0 48.9584 0 51.1081C0 53.2578 1.74267 55.0005 3.89235 55.0005Z",
    fill: "url(#paint12_linear_740_11517)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5251 55.0005C25.6748 55.0005 27.4175 53.2578 27.4175 51.1081C27.4175 48.9584 25.6748 47.2158 23.5251 47.2158C21.3754 47.2158 19.6328 48.9584 19.6328 51.1081C19.6328 53.2578 21.3754 55.0005 23.5251 55.0005Z",
    fill: "url(#paint13_linear_740_11517)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.158 55.0005C45.3077 55.0005 47.0503 53.2578 47.0503 51.1081C47.0503 48.9584 45.3077 47.2158 43.158 47.2158C41.0083 47.2158 39.2656 48.9584 39.2656 51.1081C39.2656 53.2578 41.0083 55.0005 43.158 55.0005Z",
    fill: "url(#paint14_linear_740_11517)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7829 55.0005C64.9326 55.0005 66.6753 53.2578 66.6753 51.1081C66.6753 48.9584 64.9326 47.2158 62.7829 47.2158C60.6333 47.2158 58.8906 48.9584 58.8906 51.1081C58.8906 53.2578 60.6333 55.0005 62.7829 55.0005Z",
    fill: "url(#paint15_linear_740_11517)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_11517",
    x1: 1.80112,
    y1: 4.40137,
    x2: 7.72871,
    y2: 4.39994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_740_11517",
    x1: 21.4339,
    y1: 4.40137,
    x2: 27.3615,
    y2: 4.39994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_740_11517",
    x1: 41.0667,
    y1: 4.40137,
    x2: 46.9943,
    y2: 4.39994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_740_11517",
    x1: 60.6917,
    y1: 4.40137,
    x2: 66.6193,
    y2: 4.39994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_740_11517",
    x1: 1.80112,
    y1: 20.1396,
    x2: 7.72871,
    y2: 20.1382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_740_11517",
    x1: 21.4339,
    y1: 20.1396,
    x2: 27.3615,
    y2: 20.1382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_740_11517",
    x1: 41.0667,
    y1: 20.1396,
    x2: 46.9943,
    y2: 20.1382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_740_11517",
    x1: 60.6917,
    y1: 20.1396,
    x2: 66.6193,
    y2: 20.1382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_740_11517",
    x1: 1.80112,
    y1: 35.8779,
    x2: 7.72871,
    y2: 35.8765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_740_11517",
    x1: 21.4339,
    y1: 35.8779,
    x2: 27.3615,
    y2: 35.8765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_740_11517",
    x1: 41.0667,
    y1: 35.8779,
    x2: 46.9943,
    y2: 35.8765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_740_11517",
    x1: 60.6917,
    y1: 35.8779,
    x2: 66.6193,
    y2: 35.8765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_740_11517",
    x1: 1.80112,
    y1: 51.6172,
    x2: 7.72871,
    y2: 51.6158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_740_11517",
    x1: 21.4339,
    y1: 51.6172,
    x2: 27.3615,
    y2: 51.6158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_740_11517",
    x1: 41.0667,
    y1: 51.6172,
    x2: 46.9943,
    y2: 51.6158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_740_11517",
    x1: 60.6917,
    y1: 51.6172,
    x2: 66.6193,
    y2: 51.6158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots4);
export default __webpack_public_path__ + "static/media/dots-4.738a768ff9eb5732c9e6630513717cce.svg";
export { ForwardRef as ReactComponent };